import { createBrowserRouter, RouterProvider, Route, Outlet, Navigate } from 'react-router-dom';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import initAndroidBack from './utils/backAndroid';
import Topbar from './components/topbar/Topbar';
import { ToastContainer, toast } from 'react-toastify';
import MajApp from './components/MajApp';
import AProposApp from './components/AProposApp';
import 'react-toastify/dist/ReactToastify.css';
import ToastSansAnimation from './utils/toastTransition';
import './App.css';
import HomeDashboard from './pages/rightbar/HomeDashboard';
import { HashLoader } from 'react-spinners';
import Page404 from './pages/page404/Page404';
import Login1 from './pages/login1/Login1';
import Register1 from './pages/register1/Register1';
import Products from './pages/products/Products';
import ProductForm from './pages/products/form/ProductForm';
import Ventes from './pages/ventes/Ventes';
import Categories from './pages/categories/Categories';
import Emplacement from './pages/emplacement/Emplacement';
import Client from './pages/client/Client';
import Livreur from './pages/livreur/Livreur';
import LivreurForm from './pages/livreur/livreurForm/LivreurForm';
import Utilisateurs from './pages/utilisateurs/Utilisateurs';
import UtilisateurForm from './pages/utilisateurs/utilisateurForm/UtilisateurForm';
import ProductView from './pages/products/productView/ProductView';
import VenteView from './pages/ventes/venteView/VenteView';
import RetourForm from './pages/retour/retourForm/RetourForm';
import Retour from './pages/retour/Retour';
import EchangeForm from './pages/echange/echangeForm/EchangeForm';
import CentreEchanges from './pages/echange/CentreEchanges';
import Matiere from './pages/matiere/Matiere';
import Marque from './pages/marque/Marque';
import FormProduitEdit from './pages/products/formEdit/FormProduitEdit';
import CentrePilotage from './pages/pilotage/CentrePilotage';
/* RapportVenteChart, sa route et faker ont ete RETIRES le 22/08/2026.

   Cet ecran etait inatteignable depuis le 05/07 (route commentee), mais son
   IMPORT etait reste actif : il suffisait a maintenir l arete dans le graphe
   webpack, donc a embarquer faker — un generateur de FAUSSES donnees, 2 Mo
   bruts — dans la production. Retirer la seule ligne d import avait deja rendu
   ~539 Ko gzip.

   Aujourd hui la route part a son tour, donc le composant et la dependance
   avec elle. Une bibliotheque de fausses donnees n a rien a faire dans les
   dependances d une application qui compte de l argent reel. */
import RapportDachats from './pages/rapport/rapportDachat/RapportDachats';
import LivreurEdit from './pages/livreur/livreurEdit/LivreurEdit';
import ClientEdit from './pages/client/clientEdit/ClientEdit';
import UtilisateurEdit from './pages/utilisateurs/utilisateurEdit/UtilisateurEdit';
import VarianteProduit from './pages/varianteProduit/VarianteProduit';
import PageDetails from './pages/PageDetails/PageDetails';
import TypeMouvement from './pages/typeMouvement/TypeMouvement';
import Mouvement from './pages/mouvement/Mouvement';
import FormMouvement from './pages/mouvement/formMouvement/FormMouvement';
import Commande from './pages/commande/Commande';
import Cart from './pages/commande/cart/Cart';
import DetailProduitCommande from './pages/commande/detaillProduitCommande/DetailProduitCommande';
import NouvelleCommande from './pages/commande/commandeWizard/NouvelleCommande';
import ListeCommande from './pages/commande/ListeCommande/ListeCommande';
import CommandesDormantes from './pages/commande/CommandesDormantes';
import ListeDetailCommande from './pages/commande/listeDetailCommande/ListeDetailCommande';
import EditCommande from './pages/commande/editCommande/EditCommande';
import ListeDetailView from './pages/commande/listeDetailView/ListeDetailView';
import Livraison from './pages/livraison/Livraison';
import Livraison_detail from './pages/livraison/livraison_detail/Livraison_detail';
import { useSelector, useDispatch } from 'react-redux';
import LivraisonForm from './pages/livraison/livraisonForm/LivraisonForm';
import PageLivreur from './pages/pageLivreur/PageLivreur';
import MobileDeliveryHub from './pages/pageLivreur/mobileDeliveryHub';
import PageLivreurNavbar from './pages/pageLivreur/pageNavbar/PageLivreurNavbar';
import LivreurBottomNav from './pages/pageLivreur/pageNavbar/LivreurBottomNav';
import LivreurDrawer from './pages/pageLivreur/pageNavbar/LivreurDrawer';
import LivreurFinalizeBanner from './pages/pageLivreur/LivreurFinalizeBanner';
import MonActiviteJour from './pages/pageLivreur/MonActiviteJour';
import Page405 from './pages/page404/page405';
import MouvementView from './pages/mouvement/mouvementView/MouvementView';
import LivraisonView from './pages/livraison/livraisonView/LivraisonView';
import Couleur from './pages/couleur/Couleur';
import HauteurTalon from './pages/hauteurTalon/HauteurTalon';
import ListeVariante from './pages/varianteProduit/listeVariante/ListeVariante';
import RapportClient from './pages/rapport/rapportClient/RapportClient';
import RapportRevenu from './pages/rapport/rapportRevenu/RapportRevenu';
import CatDepenses from './pages/depenses/catDepenses/CatDepenses';
import RapportCouleurAll from './pages/rapport/rapportVente/rapportVenteCouleur/RapportCouleurAll';
import Dette from './pages/dette/Dette';
import Paiement from './pages/paiement/Paiement';
import CentreCreances from './pages/creances/CentreCreances';
import Reception from './pages/reception/Reception';
import CatReception from './pages/reception/catReception/CatReception';
import QualificationAttributs from './pages/attributs/QualificationAttributs';
import ParametresCriteres from './pages/attributs/ParametresCriteres';
import ReceptionArrivage from './pages/reception/ReceptionArrivage';
import CoutsAchat from './pages/reception/CoutsAchat';
import ReceptionOne from './pages/reception/ReceptionOne';
import DetteOne from './pages/dette/DetteOne';
import MouvementLivreur from './pages/mouvement/mouvementLivreur/MouvementLivreur';
import ClientAdresse from './pages/client/clientAdresse/ClientAdresse';
import ClientTelephone from './pages/client/clientTelephone/ClientTelephone';
import Permissions from './pages/permissions/Permissions';
import EchangeCat from './pages/echange/echangeCat/EchangeCat';
import PageDetailEdit from './pages/PageDetails/PageDetailEdit/PageDetailEdit';
import ClientView from './pages/client/ClientView';
import ClientLocation from './pages/client/clientLocation/ClientLocation';
import RapportCaisse from './pages/rapport/rapportCaisse/RapportCaisse';
import DepensesAll from './pages/depenses/DepensesAll';
import axios from 'axios';
import config from './config';
import usePermissions from './hooks/usePermissions';
import { lireCasquette } from './hooks/useCasquette';
import { fetchDataRequest, fetchDataFailure, fetchDataSuccess } from "./redux/userRedux";
import ClientForm from './pages/client/clientForm/ClientForm';
import PasswordForgot from './pages/passewordForgot/PasswordForgot';
import PermissionOne from './pages/permissions/permissionOne/PermissionOne';
import Options from './components/sidebar/Options';
import { GlobalBottomNav } from './components/ndoe';
import Profile from './pages/profile/Profile';
import PagePrefsNotifications from './pages/profile/PagePrefsNotifications';
import RapportDepense from './pages/rapport/rapportDepense/RapportDepense';
import JournalStockAll from './pages/journalStock/journalStockAll/JournalStockAll';
import JournalTransactions from './pages/journalTransactions/JournalTransactions';
import StockReconciliation from './pages/stockReconciliation/StockReconciliation';
import Reservations from './pages/reservations/Reservations';
import Precommandes from './pages/precommandes/Precommandes';
import Inventaires from './pages/inventaires/Inventaires';
import InventaireComptage from './pages/inventaires/InventaireComptage';
import InventaireSession from './pages/inventaires/InventaireSession';
import InventaireEquipe from './pages/inventaires/InventaireEquipe';
import InventaireCloture from './pages/inventaires/InventaireCloture';
import InventaireDirect from './pages/inventaires/InventaireDirect';
import PerformanceProduits from './pages/rapports/PerformanceProduits';
import VentesParVendeur from './pages/rapports/VentesParVendeur';
import RapportVentes from './pages/rapports/RapportVentes';
import RapportClients from './pages/rapports/RapportClients';
import RapportRevenus from './pages/rapports/RapportRevenus';
import RapportApprovisionnement from './pages/rapports/RapportApprovisionnement';
import RapportDepenses from './pages/rapports/RapportDepenses';
import RupturesInteressantes from './pages/rapports/RupturesInteressantes';
import RotationStock from './pages/rapports/RotationStock';
import ProduitsDormants from './pages/rapports/ProduitsDormants';
import AnalysePointures from './pages/rapports/AnalysePointures';
import AnalyseAnciennete from './pages/rapports/AnalyseAnciennete';
import RelanceClientes from './pages/rapports/RelanceClientes';
import Fidelisation from './pages/rapports/Fidelisation';
import AnalyseDimensions from './pages/rapports/AnalyseDimensions';
import PertesEtZones from './pages/rapports/PertesEtZones';
import EssaisRetours from './pages/rapports/EssaisRetours';
import EvolutionVentes from './pages/rapports/EvolutionVentes';
import DecisionsRecommandees from './pages/rapports/DecisionsRecommandees';
import VueEnsemble from './pages/rapports/VueEnsemble';
import MobileCockpit from './pages/mobileCockpit/MobileCockpit';
import ParametresBoutique from './pages/parametres/ParametresBoutique';
import JournalModifications from './pages/journalModifications/JournalModifications';
import JournalSuppressions from './pages/journalSuppressions/JournalSuppressions';
import WhatsAppSettings from './pages/whatsapp/WhatsAppSettings';
import RapportModifications from './pages/rapports/RapportModifications';
import PermissionsMatrice from './pages/permissionsMatrice/PermissionsMatrice';
import PartageCatalogue from './pages/partageCatalogue/PartageCatalogue';
import FeuilleDepense from './pages/feuilleDepense/FeuilleDepense';
import ValidationDepenses from './pages/validationDepenses/ValidationDepenses';
import AnalyseDepenses from './pages/validationDepenses/AnalyseDepenses';
import PhotosPartage from './pages/photosPartage/PhotosPartage';
import Promotions from './pages/promotions/Promotions';
import CentreRegularisation from './pages/regularisation/CentreRegularisation';
import PageSentinelle from './pages/sentinelle/PageSentinelle';
import FusionDoublons from './pages/fusionDoublons/FusionDoublons';
import NouveauProduit from './pages/catalogue/NouveauProduit';

function App() {
/*   const { currentUser } = useContext(AuthContext); */
const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
const dispatch = useDispatch();
const user = useSelector((state) => state.user?.currentUser);
// Profil mixte : c'est le SERVEUR qui dit si ce livreur peut exercer comme
// vendeur (permission accordée par l'admin, révocable à tout moment).
const { profilMixte: permsProfilMixte } = usePermissions();
const userId = useSelector((state) => state.user?.currentUser?.id);
const [data, setData] = useState([]);
/* const loading = useSelector((state) => state.user?.loading);
 */
const [loading, setLoading] = useState(false);

/*   useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(fetchDataRequest());

        const res = await axios.get(`${DOMAIN}/api/produit/produitCount`);
        dispatch(fetchDataSuccess(res.data));

      } catch (error) {
        console.log(error);
        dispatch(fetchDataFailure());
      }
    };

    fetchData();
  }, [DOMAIN]); */

  // Modèle de sécurité à deux couches (Lot F) :
  //  1. NAVIGATION (ce que l'utilisateur VOIT) = permissions par utilisateur,
  //     chargées ici (menus/permission) et rendues par <Options data={data}/>.
  //     Un admin les gère dans /permission. C'est du confort d'affichage.
  //  2. SÉCURITÉ (ce que le serveur AUTORISE) = verifyToken + requireRole côté
  //     API (paliers 2a/2b). C'est la vraie barrière : cacher un menu ne protège
  //     rien à lui seul, l'API refuse déjà selon le rôle. (Ex-Sidebar.jsx par
  //     rôle : supprimé, il n'était pas rendu.)
  const fetchMenu = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${DOMAIN}/api/inventaire/menuAll/addOne?userId=${userId}`);
      setData(data);
    } catch (error) {
      console.log(error);
    }finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      fetchMenu();
    } else {
      setLoading(false);
    }
  }, [userId, fetchMenu]);

  // Bouton Back matériel Android (APK Capacitor) — sans effet sur le web.
  useEffect(() => { initAndroidBack(); }, []);

  // Fermeture auto des toasts pilotée en JS : le minuteur natif de
  // react-toastify repose sur l'ANIMATION CSS de la barre de progression —
  // gelée par certaines WebView Android, le toast ne se fermait jamais
  // (voir utils/toastTransition). Un vrai setTimeout ferme toujours ;
  // dismiss d'un toast déjà parti = sans effet.
  useEffect(() => toast.onChange((e) => {
    if (e.status === 'added') setTimeout(() => toast.dismiss(e.id), 2800);
  }), []);

  const Layout = () => {
      
    return (
      <div >
        <Topbar/>
        <div className="appContainer">
          <Options data={data}/>
          <div className="appOutlet">
            <Outlet />
          </div>
        </div>
        {/* ⑩ Barre de navigation basse (mobile, gardée par permissions). */}
        <GlobalBottomNav />
      </div>
    );
  };

  const Layout2 = () => {

    return (
      <div>
        <PageLivreurNavbar/>
        <LivreurFinalizeBanner />
        <div className="pageNavbar">
          <Outlet />
        </div>
        <LivreurBottomNav />
        <LivreurDrawer />
      </div>
    );
  };

 const SecuriteRoute = ({ children }) => {
    if (!user) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  // Routeur MÉMOÏSÉ : il était recréé à chaque render de App, ce qui
  // remontait la route affichée (perte des filtres, du scroll et des saisies
  // en cours dès qu'un état de App bougeait). Dépendances : le rôle décide
  // des branches de routes, `data` alimente <Options> dans Layout.
  // PROFIL MIXTE : un livreur autorisé à exercer aussi comme vendeur bascule sa
  // NAVIGATION (pas son rôle, ni ses droits — le serveur reste l'autorité). La
  // casquette est fail-closed : sans le privilège serveur, on reste « livreur ».
  const roleNav = (user?.role === 'livreur' && permsProfilMixte && lireCasquette() === 'vendeur')
    ? 'vendeur'
    : (user?.role ?? null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const router = useMemo(() => createBrowserRouter([
    (roleNav === 'admin' || roleNav === 'secretaire' || roleNav === 'vendeur') && {
      path: '/',
      element: <SecuriteRoute><Layout /></SecuriteRoute>,
      children: [
        {
          path: '/',
          element: <HomeDashboard />
        },
        {
          path: '/mobile',
          element: <MobileCockpit />
        },
        {
          // Supervision des livraisons par l'admin : hub livreur + sélecteur de
          // livreur (l'admin opère les livraisons de n'importe quel livreur).
          path: '/supervision-livraisons',
          element: <MobileDeliveryHub />
        },
        {
          path: '/products',
          element: <Products />
        },
        {
          path: '/productView/:id',
          element: <ProductView />
        },
        {
          path: '/productForm',
          element: <ProductForm />
        },
        {
          path: '/productForm/:id',
          element: <FormProduitEdit />
        },
        {
          // Assistant « Nouveau modèle » : identité, matrice couleur × pointure,
          // prix et premier arrivage — en UNE transaction côté serveur.
          path: '/catalogue/nouveau',
          element: <NouveauProduit />
        },
        {
          path: '/varianteProduit',
          element: <VarianteProduit />
        },
        {
          // M5bis : catalogue de partage WhatsApp (photos composées + bande infos).
          path: '/partage-catalogue',
          element: <PartageCatalogue />
        },
        {
          // Photos « mannequin » à partager (5 max/modèle) — la page vérifie la
          // permission photos_partage.gerer (matrice) et affiche un accès refusé propre.
          path: '/photos-partage',
          element: <PhotosPartage />
        },
        {
          // Prix promotionnels — la page vérifie promotions.encoder/valider
          // (matrice) et affiche un accès refusé propre sinon.
          path: '/promotions',
          element: <Promotions />
        },
        {
          // Centre de régularisation (fiche 360° commande+livraison) — la page
          // vérifie regularisation.acceder (matrice) et refuse proprement sinon.
          path: '/regularisation',
          element: <CentreRegularisation />
        },
        {
          // Sentinelle d'intégrité (écarts stock, écritures directes, créances)
          // — admin uniquement (la page ET l'API vérifient le rôle).
          path: '/sentinelle',
          element: <PageSentinelle />
        },
        {
          // Fusion de doublons produit — admin (la page ET l'API vérifient le rôle).
          path: '/fusion-doublons',
          element: <FusionDoublons />
        },
        {
          path: '/listeVariante',
          element: <ListeVariante />
        },
        {
          path: '/pageDetail/:id',
          element: <PageDetails />
        },
        {
          path: '/pageDetailEdit/:id',
          element: <PageDetailEdit />
        },
        {
          path: '/categories',
          element: <Categories />
        },
        {
          path: '/categories/:id',
          element: <Categories  />
        },
        {
          path: '/emplacement',
          element: <Emplacement />
        },
        {
          path: '/emplacement/:id',
          element: <Emplacement />
        },
        {
          path: '/matiere',
          element: <Matiere />
        },
        {
          path: '/matiere/:id',
          element: <Matiere />
        },
        {
          path: '/marque',
          element: <Marque />
        },
        {
          path: '/marque/:id',
          element: <Marque />
        },
        {
          path: '/typeMouvement',
          element: <TypeMouvement />
        },
        {
          path: '/qualification-criteres',
          element: <QualificationAttributs />
        },
        {
          path: '/parametres-criteres',
          element: <ParametresCriteres />
        },
        {
          path: '/hauteur-talon',
          element: <HauteurTalon />
        },
        {
          path: '/couleur',
          element: <Couleur />
        },
        {
          path: '/mouvement',
          element: <Mouvement />
        },
        {
          path: '/mouvement/:id',
          element: <MouvementView />
        },
        {
          path: '/mouvementOne/:id',
          element: <MouvementLivreur />
        },
        {
          path: '/mouvementForm',
          element: <FormMouvement />
        },
        {
          path: '/commandes/:id',
         element: <Commande /> 
        },
        {
          path: '/commande/:id/:id_commande',
         element: <DetailProduitCommande /> 
        },
        {
          path: '/commandeForm',
         element: <NouvelleCommande />
        },
        {
          path: '/Editcommande/:id',
         element: <EditCommande /> 
        },
        {
          path: '/listeCommande',
         element: <ListeCommande />
        },
        {
          // Ménage des commandes affectées jamais prises en charge : elles
          // réservent du stock (mesuré : 283 paires immobilisées).
          path: '/commandesDormantes',
          element: <CommandesDormantes />,
        },
        {
          path: '/listeDetailCommande',
         element: <ListeDetailCommande /> 
        },
        {
          path: '/listeDetailView/:id',
         element: <ListeDetailView /> 
        },
        {
          path: '/cart',
          element: <Cart/> 
        },
        {
          path: '/livraison',
          element: <Livraison/> 
        },
        {
          path: '/livraison_detail',
          element: <Livraison_detail/> 
        },
        {
          path: '/livraisonForm',
          element: <LivraisonForm/> 
        },
        {
          path: '/livraisonView/:id',
          element: <LivraisonView/> 
        },
        {
          path: '/ventes',
          element: <Ventes />
        },
        {
          path: '/venteView/:id',
          element: <VenteView />
        },
        {
          path: '/ventes/:id',
          element: <Ventes />
        },
        {
          path: '/retour',
          element: <Retour/>
        },
        {
          path: '/retourForm',
          element: <RetourForm />
        },
        {
          path: '/retour/:id',
          element: <Retour/>
        },
        /* SUPPRIMÉ le 12/08/2026 : la route /echange et son écran.
           L'échéance qu'elle portait (26/07) était passée, et l'écran ne
           marchait de toute façon plus — il appelait GET /api/vente/echange et
           /echangeOne/:id, qui n'existent PAS côté serveur. L'erreur partait
           dans un console.log et `setLoading(false)` n'était que dans le
           chemin qui réussit : un spinner éternel, en silence.
           Remplacé par /centreEchanges. */
        {
          path: 'echange/:id',
          element: <EchangeCat/>
        },
        {
          // Centre des echanges : demandes / en cours / historique en un seul
          // endroit (le cycle vivait eclate sur trois ecrans sans lien).
          path: '/centreEchanges',
          element: <CentreEchanges />,
        },
        {
          path: '/echangeForm',
          element: <EchangeForm/>
        },
        {
          path: '/clients',
          element: <Client />
        },
         {
          path: '/clientForm',
          element: <ClientForm />
        },
         {
          path: '/clientAdresse',
          element: <ClientAdresse />
        },
        {
          path: '/clientTelephone',
          element: <ClientTelephone />
        },
        {
          path: '/clientEdit/:id',
          element: <ClientEdit />
        },
        {
          path: '/clientView/:id',
          element: <ClientView />
        },
        {
          path: '/clientLocalisation',
          element: <ClientLocation />
        },
        {
          path: '/livreur',
          element: <Livreur />
        },
        {
          path: '/livreurForm',
          element: <LivreurForm />
        },
        {
          path: '/livreurEdit/:id',
          element: <LivreurEdit />
        },
        {
          path: '/livreurForm/:id',
          element: <LivreurForm />
        },
        {
          path: '/utilisateurs',
          element: <Utilisateurs/>
        },
        {
          path: '/utilisateurForm',
          element: <UtilisateurForm />
        },
        {
          path: '/utilisateurEdit/:id',
          element: <UtilisateurEdit/>
        },
        {
          path: '/depensesAll',
          element: <DepensesAll/>
        },
        {
          // Déclaration de ses propres dépenses du jour. Le LIVREUR y accède par
          // son propre layout (bloc plus bas) ; cette route-ci sert aux profils
          // de bureau à qui on accorde « depenses.declarer » dans la matrice.
          path: '/ma-feuille-depense',
          element: <FeuilleDepense/>
        },
        {
          // Validation des feuilles + supervision des lieux à rattacher.
          // Réservée au bureau (permission depenses.valider) : pas de route
          // équivalente dans le bloc livreur, c'est volontaire.
          path: '/validation-depenses',
          element: <ValidationDepenses/>
        },
        {
          // Analyse des coûts de trajet (permission depenses.analyser, admin).
          path: '/analyse-depenses',
          element: <AnalyseDepenses/>
        },
        {
          path: '/catDepenses',
          element: <CatDepenses/>
        },
        {
          path: '/rapportVente',
          element: <Navigate to="/rapports/ventes" replace />
        },
        {
          path: '/rapportVenteMarque',
          element: <Navigate to="/rapports/ventes" replace />
        },
        {
          path: '/rapportCat',
          element: <Navigate to="/rapports/ventes" replace />
        },
        {
          path: '/rapportClient',
          element: <Navigate to="/rapports/clients" replace />
        },
        {
          path: '/rapportCouleurAll/:id/:id_marque',
          element: <RapportCouleurAll/>
        },
        {
          path: '/rapportRevenu',
          element: <Navigate to="/rapports/revenus" replace />
        },
        {
          path: '/rapportDachats',
          element: <Navigate to="/rapports/approvisionnement" replace />
        },
        {
          path: '/rapportDepense',
          element: <Navigate to="/rapports/depenses" replace />
        },
        {
          path: '/creances',
          element: <CentreCreances />
        },
        {
          path: '/dette',
          element: <Dette />
        },
        {
          path: '/dette/:id',
          element: <DetteOne />
        },
        {
          path: '/paiement',
          element: <Paiement />
        },
        {
          path: '/entreeStock',
          element: <CatReception />
        },
        {
          path: '/reception',
          element: <Reception />
        },
        {
          // Réception V2 : arrivage transactionnel + coût d'achat. L'ancien
          // DetailReception (un POST par pointure, sans transaction ni coût)
          // est remplacé — même URL, le catalogue /entreeStock y mène toujours.
          path: '/detailReception/:id',
          element: <ReceptionArrivage />
        },
        {
          path: '/couts-achat',
          element: <CoutsAchat />
        },
        {
          path: '/receptionOne/:id',
          element: <ReceptionOne />
        },
        {
          path: '/permission',
          element: <Permissions />
        },
        {
          path: '/parametres-boutique',
          element: <ParametresBoutique />
        },
        {
          /*
            CENTRE DE PILOTAGE — surface d'ESSAI (22/08/2026).

            Elle ne remplace ni ne redirige l'Accueil ni « En direct » : la
            décision produit était explicitement de garder les trois côte à
            côte le temps de comparer. Elle n'appelle AUCUNE route nouvelle —
            uniquement /api/dashboard/admin, déjà servie à l'Accueil.
          */
          path: '/pilotage',
          element: <CentrePilotage />
        },
        {
          path: '/permissions-matrice',
          element: <PermissionsMatrice />
        },
        {
          path: '/journal-modifications',
          element: <JournalModifications />
        },
        {
          path: '/journal-suppressions',
          element: <JournalSuppressions />
        },
        {
          path: '/notifications-whatsapp',
          element: <WhatsAppSettings />
        },
        // Route RESTAUREE le 22/08/2026 : elle etait commentee comme « morte »,
        // mais l'ecran « Utilisateurs (liste) » (au menu Administration) porte un
        // bouton oeil qui pointe ici. Il menait a une page blanche depuis le 05/07.
        {
          path: '/permissionOne',
          element: <PermissionOne />
        },
        {
          path: '/caisse',
          element: <RapportCaisse/>
        },
        {
          path: '/journal_stock',
          element: <JournalStockAll />
        },
        {
          path: '/journal_transactions',
          element: <JournalTransactions />
        },
        {
          path: '/reconciliation_stocks',
          element: <StockReconciliation />
        },
        {
          path: '/reservations',
          element: <Reservations />
        },
        {
          path: '/precommandes',
          element: <Precommandes />
        },
        {
          path: '/inventaires',
          element: <Inventaires />
        },
        {
          path: '/inventaires/:id',
          element: <InventaireSession />
        },
        {
          // Écran de COMPTAGE : tenu à la main devant les cartons. Distinct de
          // la session, qui est une vue de pilotage — on ne compte pas depuis
          // un tableau.
          path: '/inventaires/:id/compter',
          element: <InventaireComptage />
        },
        {
          // Vue du PILOTE : qui compte (équipes, passes) et où en est-on.
          path: '/inventaires/:id/equipe',
          element: <InventaireEquipe />
        },
        {
          // CLÔTURE : trier les écarts par cause avant d'écrire dans le stock.
          path: '/inventaires/:id/cloturer',
          element: <InventaireCloture />
        },
        {
          // SUIVI EN DIRECT : ou en est le comptage, par equipe et par personne.
          path: '/inventaires/:id/direct',
          element: <InventaireDirect />
        },
        {
          path: '/rapports/modifications',
          element: <RapportModifications />
        },
        {
          path: '/rapports/ventes',
          element: <RapportVentes />
        },
        {
          path: '/rapports/clients',
          element: <RapportClients />
        },
        {
          path: '/rapports/revenus',
          element: <RapportRevenus />
        },
        {
          path: '/rapports/approvisionnement',
          element: <RapportApprovisionnement />
        },
        {
          path: '/rapports/depenses',
          element: <RapportDepenses />
        },
        {
          // Ventes au COMPTOIR par personne — rendu possible par vente.canal ;
          // c'est là que se lit le chiffre d'un livreur à profil mixte.
          path: '/rapports/vendeurs',
          element: <VentesParVendeur />
        },
        {
          path: '/rapports/performance',
          element: <PerformanceProduits />
        },
        {
          path: '/rapports/ruptures',
          element: <RupturesInteressantes />
        },
        {
          path: '/rapports/rotation',
          element: <RotationStock />
        },
        {
          path: '/rapports/dormants',
          element: <ProduitsDormants />
        },
        {
          path: '/rapports/pointures',
          element: <AnalysePointures />
        },
        {
          path: '/rapports/anciennete',
          element: <AnalyseAnciennete />
        },
        {
          path: '/rapports/relance',
          element: <RelanceClientes />
        },
        {
          path: '/rapports/fidelisation',
          element: <Fidelisation />
        },
        {
          path: '/rapports/dimensions',
          element: <AnalyseDimensions />
        },
        {
          path: '/rapports/pertes-zones',
          element: <PertesEtZones />
        },
        {
          path: '/rapports/retours',
          element: <EssaisRetours />
        },
        {
          path: '/rapports/evolution',
          element: <EvolutionVentes />
        },
        {
          path: '/rapports',
          element: <VueEnsemble />
        },
        {
          path: '/rapports/decisions',
          element: <DecisionsRecommandees />
        },
        {
          path: '/profile',
          element: <Profile/>
        },
        {
          path: '/preferences-notifications',
          element: <PagePrefsNotifications />
        }
      ]
    }, roleNav === 'livreur' && {
      path: '/',
      element: <SecuriteRoute><Layout2 /></SecuriteRoute>,
      children: [
        {
          path: '/',
          element: <PageLivreur />
        },
        {
          // Préférences de notification du LIVREUR (constat revue #98 : le
          // lien « Paramètres » de la cloche menait à /profile, capté par le
          // catch-all → impossible de couper les alertes). AVANT le /*.
          path: '/preferences-notifications',
          element: <PagePrefsNotifications />
        },
        {
          // ⑦ : accès livreur au catalogue de partage (permission partage.voir,
          // activable dans la matrice). DOIT être avant le catch-all /* qui
          // redirige sinon tout vers le hub.
          path: '/partage-catalogue',
          element: <PartageCatalogue />
        },
        {
          // Feuille de dépense du jour. DOIT être avant le catch-all /*, qui
          // renverrait sinon le livreur sur le hub. La page se garde elle-même :
          // l'API refuse sans la permission depenses.declarer.
          path: '/ma-feuille-depense',
          element: <FeuilleDepense />
        },
        {
          // Tableau de bord perso du livreur (activité du jour + encaissé déclaré).
          // Auto-scopé côté API. AVANT le catch-all /*.
          path: '/mon-activite',
          element: <MonActiviteJour />
        },
        {
          // Ancien parcours livreur neutralisé (parcours V2 mobile-delivery seul).
          // Toute ancienne URL (pageCommandeVentes, pageRetourCommande, echange…)
          // est redirigée vers le hub — plus aucun accès aux écrans legacy.
          path: '/*',
          element: <Navigate to="/" replace />
        }
      ]
    },
    {
      path: '/login',
      element: <Login1 />
    },
    {
      path: '/register',
      element: <Register1 />
    },
    {
      path: '/forgot',
      element: <PasswordForgot />
    },
    user?.role === null && {
      path: '/*',
      element: <Page405 />
    },
    {
      path: '/*',
      element:<SecuriteRoute><Page404 /></SecuriteRoute>
    },
  ]), [roleNav, user, data]);

  return (
    <div>
    {/* Feedback global (⑥) : au plus 2 toasts empilés, auto-fermeture 2,5 s, le
        plus récent au-dessus, couleurs succès/erreur nettes, centré (visible en
        mobile). Évite les erreurs périmées affichées en même temps que le succès.
        transition SANS animation + fermeture JS (voir utils/toastTransition) :
        les WebView Android gèlent parfois les animations CSS → sans ça, le
        message n'apparaissait qu'à la transition de page suivante (APK 15/07).
        Barre de progression masquée : gelée, elle mentirait sur le temps restant. */}
    <ToastContainer position="top-center" autoClose={2500} limit={2} newestOnTop closeOnClick pauseOnFocusLoss={false} theme="colored" transition={ToastSansAnimation} hideProgressBar />
      {/* Mise à jour in-app (APK sideload) : n'affiche rien sur le web ni si l'app
          est à jour ; sinon bandeau optionnel ou écran bloquant. Fail-open. */}
      <MajApp />
      <AProposApp />
      {loading ? (
      <div className="spinnerContainer">
        <HashLoader color="rgb(131, 159, 241)" loading={loading} height={15} radius={2} margin={2} />
      </div>
      ) : (
        <RouterProvider key={roleNav} router={router} />
      )}
    </div>
  );
}

export default App;